import React from 'react';
import { Grid2 as Grid, Box } from '@mui/material';

const CELL_WIDTH = 70;

const PreviewRowTabular = ({
  row,
  isLast,
  hasManyColumns,
}: {
  row: string[];
  isLast: boolean;
  hasManyColumns: boolean;
}) => {
  return (
    <Box
      sx={{
        borderBottom: isLast ? 'none' : '1px solid',
        borderColor: 'divider',
        px: 1,
        py: 0.5,
      }}
    >
      <Grid container spacing={1} wrap="nowrap">
        {row.map((cell, cellIndex) => (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={cellIndex}
            title={cell}
            sx={{
              ...(hasManyColumns
                ? {
                    width: CELL_WIDTH,
                    maxWidth: CELL_WIDTH,
                    flexShrink: 0,
                  }
                : {
                    flex: 1,
                    minWidth: 0,
                  }),

              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontSize: 13,
            }}
          >
            {cell || '—'}
          </Box>
        ))}
      </Grid>
    </Box>
  );
};

export default PreviewRowTabular;
